import { Box, Stack } from '@mui/material'

interface OrbitComponentProps {}

const OrbitComponent: React.FC<OrbitComponentProps> = ({}) => {
  return (
    <Stack
      gap='0.7rem'
      sx={{
        padding: '0.7rem',
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        background: '#FBFBFB',
      }}
    ></Stack>
  )
}

export default OrbitComponent
